<template>
  <article class="lg:col-span-12">
    <a
      :href="hit.url"
      class="flex group gap-3 py-4 border-b border-b-blue-100"
    >
      <img
        v-if="hit.image"
        :src="hit.image"
        alt=""
        aria-hidden="true"
        class="object-contain h-24 self-start shrink-0"
        loading="lazy"
      >
      <div class="inline-flex flex-col gap-2">
        <div>
          <span
            class="flex-none rounded-full px-2 py-0.5 inline-flex text-xs font-medium justify-center items-center text-blue-700  bg-blue-200 capitalize"
            v-text="hit.displayHitType"
          />
        </div>

        <h3 class="text-xl md:text-2xl lg:text-3xl link link--primary font-display group-hover:underline">
          {{ hit.title }}
        </h3>


        <AisSnippet
          attribute="excerpt"
          :hit="hit"
          :class-names="{
            'ais-Snippet': 'prose prose-sm',
          }"
        />
      </div>
    </a>
  </article>
</template>

<script lang="ts">
export default { name: 'PlainText' }
</script>

<script setup lang="ts">
import { AisSnippet } from 'vue-instantsearch/vue3/es'

import { Hit } from '~/types/Hit'

defineProps<{ hit: Hit }>()
</script>
  
